import { useStore } from '@nanostores/react';
import { map } from 'nanostores';
import { useCallback } from 'react';

export const $listVisiblePages = map<Record<string, number>>({});

export function useListPagination(key: string) {
  const visiblePages = useStore($listVisiblePages, { keys: [key] })[key] ?? 1;

  const showMore = useCallback(() => {
    $listVisiblePages.setKey(key, ($listVisiblePages.get()[key] ?? 1) + 1);
  }, [key]);

  const reset = useCallback(() => {
    $listVisiblePages.setKey(key, 1);
  }, [key]);

  return { visiblePages, showMore, reset };
}
